export enum DetailsTab {
    summary,
    team,
    comments,
    photos,
    notifications,
    logs,
    complete,
}
